import {
  groupLifeService,
  type ListGroupLifeQuoteVersionsResponse,
} from '@/services';
import { useQuery } from '@tanstack/react-query';

export function useGroupLifeQuoteVersions(policyId?: string) {
  return useQuery({
    queryKey: ['group-life', 'quote-versions', policyId],
    queryFn: async (): Promise<ListGroupLifeQuoteVersionsResponse> => {
      if (!policyId) throw new Error('policyId é obrigatório');
      const result = await groupLifeService.listQuoteVersions(policyId);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Falha ao carregar as versões');
      }
      return result.data;
    },
    enabled: !!policyId,
    staleTime: 0,
  });
}
